import { render, staticRenderFns } from "./step-test-whatsapp-cloud.vue?vue&type=template&id=7fc20028&scoped=true"
import script from "./step-test-whatsapp-cloud.vue?vue&type=script&lang=js"
export * from "./step-test-whatsapp-cloud.vue?vue&type=script&lang=js"
import style0 from "./step-test-whatsapp-cloud.vue?vue&type=style&index=0&id=7fc20028&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc20028",
  null
  
)

export default component.exports